export const RETURN_REFUND = 'REFUND'
export const RETURN_REPLACE = 'REPLACE'

export const Types = [
  {
    code: RETURN_REFUND,
    label: 'Refund',
    description: 'The item(s) will be re-added to the stock'
  },
  {
    code: RETURN_REPLACE,
    label: 'Replace',
    description: 'The item(s) won\'t be re-added to the stock'
  }
]

export function getLabel (code) {
  return _.get(Types.find((x) => x.code === code), 'label')
}

export function getDescription (code) {
  return _.get(Types.find((x) => x.code === code), 'description')
}

export default Types



// WEBPACK FOOTER //
// ./src/utils/types/return.js